var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Material_ColaboradorActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Material_ColaboradorModule = class Material_ColaboradorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Material_ColaboradorActions.POST_MATERIAL_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.post("Material_Colaborador/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Material_ColaboradorActions.PUT_MATERIAL_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.put("Material_Colaborador/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Material_ColaboradorActions.DELETE_MATERIAL_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.delete("Material_Colaborador/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Material_ColaboradorActions.DELETE_RANGE_MATERIAL_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.delete("Material_Colaborador/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Material_ColaboradorActions.FILTER_MATERIAL_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.post("Material_Colaborador/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Material_ColaboradorActions.GET_MATERIAL_COLABORADOR]() {
        return new Promise(resolve => {
            fornecService.get("Material_Colaborador/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Material_ColaboradorActions.GETWITHDISABLED_MATERIAL_COLABORADOR]() {
        return new Promise(resolve => {
            fornecService.get("Material_Colaborador/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Material_ColaboradorActions.GET_BY_ID_MATERIAL_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.get("Material_Colaborador/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Material_ColaboradorActions.GET_BY_ID_COLABODADOR_MATERIAL_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.get("Material_Colaborador/GetByIdColaborador", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_ColaboradorModule.prototype, _j, null);
Material_ColaboradorModule = __decorate([
    Module
], Material_ColaboradorModule);
export default Material_ColaboradorModule;
//# sourceMappingURL=Material_ColaboradorModule.js.map